import i18n from '@/lib/i18n';

export function getCameraCreationDrawerTitle(
    connectingCount: number,
    completedCount: number,
    errorCount: number,
    totalCount: number,
): string {
    const hasActiveConnections = connectingCount > 0;

    if (hasActiveConnections) {
        return i18n.t('connecting', {
            ns: 'cameras',
            count: connectingCount,
            total: totalCount,
        });
    }

    if (errorCount > 0) {
        return i18n.t('connectedWithErrors', {
            ns: 'cameras',
            completed: completedCount,
            total: totalCount,
        });
    }

    return i18n.t('connected', {
        ns: 'cameras',
        count: completedCount,
    });
}

export function addTimestampToUrl(url: string): string {
    const urlObj = new URL(url, window.location.origin);
    urlObj.searchParams.set('_t', String(Date.now()));
    return urlObj.toString();
}
